<template> <div
  class="px-2 pt-2"
  style="text-align:left"
>
  <b-form-group
    label="Project Name"
    label-for="basicInput"
  >
    <b-form-input
      id="basicInput"
      v-model="name"
      placeholder="Enter Project Name"
    />
  </b-form-group>
  <b-form-group
    label="Owner"
    label-for="owner"
  >
    <v-select
      id="owner"
      v-model="selOwner"
      label="fullname"
      :options="optionOwner"
    />
  </b-form-group>
  <b-form-group
    label="Visibility"
    label-for="visibility"
  >
    <v-select
      id="visibility"
      v-model="selVisibility"
      multiple
      label="fullname"
      :options="optionVisibility"
    />
  </b-form-group>
  <b-form-group
    label="Tags"
    label-for="tags"
  >
    <v-select
      id="tags"
      v-model="tags"
      taggable
      multiple
      push-tags
      label="Tags"
      :options="optionTags"
    />
  </b-form-group>
  <label for="textarea-default">Description</label>
  <b-form-textarea
    id="textarea-default"
    v-model="description"
    placeholder="Textarea"
    rows="3"
  />
  <b-button
    variant="outline-success"
    class="btn-icon rounded mt-2 mb-0"
    size="md"
    @click="save"
  >
    SAVE
  </b-button>
</div>
</template>

<script>
import {
  BFormInput, BFormTextarea, BFormGroup, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store/index'
import axios from 'axios'

export default {
  components: {
    BFormGroup,
    BFormTextarea,
    BButton,
    BFormInput,
    vSelect,
  },
  props: {
    projectId: {
      required: false,
      type: Number,
      default: 0,
    },
    data: {
      required: false,
      type: [String, Object, Array],
      default: () => {},
    },
    optionTags: {
      required: true,
      type: [String, Object, Array],
      default: () => [],
    },
  },
  data() {
    return {
      name: '',
      description: '',
      selOwner: '',
      selVisibility: '',
      optionOwner: [],
      tags: [],
    }
  },
  computed: {
    optionVisibility() {
      const options = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.optionOwner.length; index++) {
        const element = this.optionOwner[index]
        if (element.id !== this.selOwner.id) {
          options.push(element)
        }
      }
      return options
    },
  },
  watch: {
    selOwner() {
      const selection = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.selVisibility.length; index++) {
        const element = this.selVisibility[index]
        if (element.id !== this.selOwner.id) {
          selection.push(element)
        }
      }
      this.selVisibility = selection
    },
  },
  created() {
    this.getUsers()
  },
  methods: {
    save() {
      const { url, port, auth } = store.state.appConfig.api
      const headers = {
        authentication: auth,
        'Content-Type': 'application/json',
      }
      const user = this.selOwner.id

      this.userTest = user
      const selection = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.selVisibility.length; index++) {
        const element = this.selVisibility[index]
        selection.push(element.id)
      }
      if (this.projectId === 0) {
        axios.post(`${url}:${port}/project`, {
          name: this.name, description: this.description, user, visibility: JSON.stringify(selection), tags: this.tags.join(','),
        }, { headers }).then(() => {
          document.location.reload()
        })
      } else {
        axios.put(`${url}:${port}/project/${this.projectId}`, {
          name: this.name, description: this.description, user, visibility: JSON.stringify(selection), tags: this.tags.join(','),
        }, { headers }).then(() => {
          document.location.reload()
        })
      }
    },
    getUsers() {
      const { url, port, auth } = store.state.appConfig.api
      const headers = {
        authentication: auth,
        'Content-Type': 'application/json',
      }
      const data = []
      this.$http.get(`${url}:${port}/users`, { headers })
        .then(response => {
          response.data.users.forEach(element => {
            data.push({
              id: element.id,
              name: element.name,
              lastname: element.lastname,
              fullname: (`${element.name} ${element.lastname}`).trim(),
            })
          })
          this.optionOwner = data

          if (this.projectId !== 0) {
            const {
              name, Owner, visibility, description, tags,
            } = this.data
            this.name = name
            this.selOwner = Owner
            this.description = description
            this.selVisibility = this.optionOwner.filter(item => JSON.parse(visibility).includes(item.id))
            this.tags = tags.filter(item => (item !== ''))
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
